<template>
  <div>
    <validation-form ref="addForm" @on-submit="addProgressReport()">
      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-field :validations="{ required: true }" name="program">
            <label>{{ $t("common.program") }}</label>
            <md-select
              id="program"
              v-model="form.program_id"
              name="program"
              required
            >
              <md-option
                v-for="program in programs"
                :key="program.id"
                :value="program.id"
              >
                {{ $t(program.name) }}
              </md-option>
            </md-select>
          </validation-field>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-field :validations="{ required: true }" name="title">
            <label>{{ $t("setting.title") }}</label>
            <md-input v-model.trim="form.title" required></md-input>
          </validation-field>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <validation-field
            :validations="{ required: true }"
            name="report type"
          >
            <label>{{ $t("common.type") }}</label>
            <md-select
              id="report_type"
              v-model="form.report_type"
              name="report_type"
              required
            >
              <md-option
                v-for="type in reportTypes"
                :key="type.id"
                :value="type.id"
              >
                {{ $t(type.name) }}
              </md-option>
            </md-select>
          </validation-field>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <checkbox-multi-select
            v-model="form.class_ids"
            :label="$t('schedule.filter_by_class')"
            :options="classes"
            @filtering="filterClass($event)"
          ></checkbox-multi-select>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-checkbox v-model="form.all_student_ids" :disabled="!totalStudent">
            {{ $t("progress_report.all_student", { total: totalStudent }) }}
          </md-checkbox>
        </div>

        <div
          v-if="!form.all_student_ids && totalStudent"
          class="md-layout-item md-size-50 md-small-size-100"
        >
          <validation-field
            :validations="{ required: true }"
            class="validate-multi-select"
            name="student"
            type="multi-select"
          >
            <template #default="{ errors }">
              <label class="multi-select-label">
                {{ $t("common.student") }}
                <span class="text-red-500">*</span>
              </label>
              <checkbox-multi-select
                v-model="form.student_ids"
                :options="students"
                @filtering="filterStudent($event)"
              ></checkbox-multi-select>
              <span class="multi-select-error">{{ errors[0] }}</span>
            </template>
          </validation-field>
        </div>
      </div>
    </validation-form>
  </div>
</template>
<script>
import { service_names, service_paths } from "../../../constants/Services";
import CheckboxMultiSelect from "../../../components/Base/CheckboxMultiSelect";
import { Message } from "../../../helpers/utils";
import debounce from "lodash/debounce";
import { ReportTemplates, ReportTypes } from "../../../constants/Report";

export default {
  name: "add-progress-report",
  components: { CheckboxMultiSelect },
  inject: ["addSuccessPR"],
  data() {
    return {
      programs: [],
      classes: [],
      classOptSelected: [],
      students: [],
      studentOptSelected: [],
      totalStudent: 0,
      reportTypes: [
        { id: ReportTypes.MidTerm, name: "submitted_report.mid_term" },
        {
          id: ReportTypes.EndOfOne,
          name: "submitted_report.end_of_semester_1"
        },
        {
          id: ReportTypes.EndOfTwo,
          name: "submitted_report.end_of_semester_2"
        }
      ],
      form: {
        program_id: "",
        title: null,
        report_type: "",
        class_ids: [],
        student_ids: [],
        all_student_ids: true
      }
    };
  },
  computed: {
    paramsGetStudent() {
      return {
        class_ids: this.form.class_ids,
        program_ids: this.form.program_id ? [this.form.program_id] : []
      };
    }
  },
  watch: {
    "form.program_id"() {
      this.getStudentList();
      this.form.student_ids = [];
    },
    "form.class_ids"(newClass) {
      this.getClassList();
      this.getStudentList();
      this.form.student_ids = [];
      this.classOptSelected = this.classes.filter(item =>
        newClass.includes(item.id)
      );
    },
    "form.student_ids"(newStudent) {
      !this.form.all_student_ids && this.getStudentList();
      this.studentOptSelected = this.students.filter(student =>
        newStudent.includes(student.id)
      );
    }
  },
  methods: {
    getProgramList() {
      this.$axios
        .get(`${service_paths.programs}`, { limit: 100 })
        .then(({ data }) => {
          if (data) {
            this.programs = data.data.filter(
              program =>
                program.report_template === ReportTemplates.Standard ||
                program.report_template === ReportTemplates.Honors ||
                program.report_template === ReportTemplates.HighSchool
            );
          }
        });
    },

    filterClass(event) {
      this.debounceClass(event.text);
    },

    debounceClass: debounce(function(searchKey) {
      this.getClassList(searchKey);
    }, 200),

    getClassList(searchKey = "") {
      this.$axios
        .get(
          `${service_paths.classes}`,
          {
            "name__~": searchKey,
            limit: 100
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          let newOptions = data.data.filter(
            item => !this.form.class_ids.includes(item.id)
          );
          this.classes = [...this.classOptSelected, ...newOptions];
        });
    },

    // get student by student_id/full name/ email or class_id or program_id
    filterStudent(event) {
      this.debounceStudent(event.text);
    },

    debounceStudent: debounce(function(searchKey) {
      this.getStudentList(searchKey, false);
    }, 200),

    getStudentList(searchKey = "", resetTotal = true) {
      this.$axios
        .get(
          `${service_names.user}/progress-setting/students/staff`,
          {
            limit: 100,
            searchKey: searchKey,
            ...this.paramsGetStudent
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.totalStudent = resetTotal ? data.total : this.totalStudent;
          let allOptions = [];
          data.data.map(student => {
            allOptions.push({
              id: student.user_sql.id,
              name: student.student_code + " - " + student.full_name
            });
          });

          let newOptions = allOptions.filter(
            item => !this.form.student_ids.includes(item.id)
          );
          this.students = [...this.studentOptSelected, ...newOptions];
        });
    },

    addProgressReport() {
      if (!this.totalStudent) {
        Message.error(this.$t("progress_report.not_exists_student"));
        return;
      }
      if (this.form.all_student_ids) {
        this.form.student_ids = [];
      }
      this.$axios
        .post(`${service_names.user}/progress/create/report`, this.form)
        .then(() => {
          this.addSuccessPR();
          Message.success(this.$t("progress_report.add_success"));
        });
    }
  },
  created() {
    this.getClassList();
    this.getProgramList();
    this.getStudentList();
  }
};
</script>
